<template>
  <div class="common-home-content" v-show="show">
    <div class="common-scroll">
      <van-search
        class="search-input"
        v-model="keyword"
        placeholder="输入方名"
        @input="onInput"
        @search="onSearch"
        @clear="onClear"
      />
      <van-list
        v-model="loading"
        :finished="finished"
        @load="getDate(false)"
        v-if="prescriptions.length > 0"
      >
        <ul class="prescriptions-ul space_pl space_pr">
          <li
            v-for="(child, index) in prescriptions"
            :key="index"
            @click="toEdit(child)"
          >
            <p class="name">{{ child.name }}
              <button class="delete" @click.stop="handleDelete(child.prescription_id)"></button>
            </p>
            <p class="content">{{ getContentDate(child.content) }}</p>
          </li>
        </ul>
        <p class="no-more" v-if="total_pages > 1 && finished">没有更多了</p>
      </van-list>
      <div class="not-prescriptions" v-else>
        <img src="../../assets/images/address/tip.png" alt="">
        <p class="title" v-if="keyword">抱歉，暂时没有搜索到您想要的~</p>
        <p class="title" v-else>您还没有常用方哦~</p>
      </div>
    </div>
    <van-popup v-model="delete_popup_show" :close-on-click-overlay="false">
      <div class="delete-popup-window">
        <p class="title">删除常用方</p>
        <p class="prompt">确认删除当前药方吗？</p>
        <div class="btns clearfix">
          <button class="fl left" @click="handleClosePopup">取消</button>
          <button class="fr right" @click="handleConfirmDelete">删除</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { _ } from "vue-underscore";
import http from "../../util/dorisApiConfig";
import { addBridgeForAndroidWebView } from "sdbridge-android";
export default {
  data() {
    return {
      show: false,
      loading: false,
      finished: false,
      delete_popup_show: false,
      select_prescription_id: "",
      token: "",
      doctor_id: 1,
      keyword: "",
      current_page: 0,
      page_size: 10,
      total_pages: 1,
      prescriptions: [],
      isApp: ""
    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if (this.isApp == "IOS") {
      bridge.callHandler("showTrBtn", { name: "新建" }, response => {});
      bridge.callHandler("getUserInfo", "", response => {
        console.log(response);
        this.token = response.token;
        this.doctor_id = response.doctor_id;
        this.platform_type = response.platform_type;
      });
      bridge.registerHandler("toEdit", (data, responseCallback) => {
        this.toEdit(false);
      });
    } else if (this.isApp == "android") {
      this.$appUtils.showAppTrBtn({ name: "新建" });
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.token = user_info.token;
        this.doctor_id = user_info.doctor_id;
        this.platform_type = user_info.platform_type;
      }
    }
    setTimeout(() => {
      this.getDate(true);
    }, 500);
    window.appTrBtnClick = () => this.toEdit(false);
    window.appBack = () => this.pageback();
  },

  methods: {
    companyFormat(str) {
      if (str == "克") {
        return "g";
      } else {
        return str;
      }
    },
    getContentDate(json) {
      let that = this;
      let str = "";
      if (json) {
        json = JSON.parse(json);
        for (let i = 0; i < json.length; i++) {
          if (i == 0) {
            if (json[i]["usage"]) {
              str =
                json[i]["name"] +
                "(" +
                json[i]["usage"] +
                ")" +
                " " +
                json[i]["quantity"] +
                that.companyFormat(json[i]["unit"]);
            } else {
              str =
                json[i]["name"] +
                " " +
                json[i]["quantity"] +
                that.companyFormat(json[i]["unit"]);
            }
          } else {
            if (json[i]["usage"]) {
              str +=
                "，" +
                json[i]["name"] +
                "(" +
                json[i]["usage"] +
                ")" +
                " " +
                json[i]["quantity"] +
                that.companyFormat(json[i]["unit"]);
            } else {
              str +=
                "，" +
                json[i]["name"] +
                " " +
                json[i]["quantity"] +
                that.companyFormat(json[i]["unit"]);
            }
          }
        }
      }
      return str;
    },
    getDate(clear) {
      let that = this;
      if (clear) {
        that.current_page = 0;
      }
      let params = {
        page: that.current_page + 1,
        page_size: that.page_size
      };
      if (that.keyword) {
        params["keyword"] = that.keyword;
      }
      that.loading = true;
      // alert(that.doctor_id+that.token)
      http
        .get("/drugs/" + that.doctor_id + "/self_prescriptions?platform_type="+that.platform_type, {
          params: params,
          headers: {
            Authorization: that.token
          }
        })
        .then(function(res) {
          if (res.data.status_code == 200) {
            if (clear) {
              that.prescriptions = [];
            }
            that.prescriptions = that.prescriptions.concat(
              res.data.data.prescriptions
            );
            that.current_page = parseInt(res.data.data.current_page);
            that.total_pages = parseInt(res.data.data.total_pages);
            if (that.current_page >= that.total_pages) {
              that.finished = true;
            } else {
              that.finished = false;
            }
          }
          that.loading = false;
          that.show = true;
          that.$appUtils.appCloseLoadingView();
        });
    },
    throttleFun: _.throttle(
      function() {
        this.finished = false;
        this.getDate(true);
      },
      200,
      { leading: false }
    ),
    onInput() {
      this.throttleFun();
    },
    onSearch() {
      this.finished = false;
      this.getDate(true);
    },
    onClear() {},
    handleDelete(id) {
      this.select_prescription_id = id;
      this.delete_popup_show = true;
    },
    handleClosePopup() {
      this.delete_popup_show = false;
    },
    handleConfirmDelete() {
      let that = this;
      let params = {
        prescription_id: that.select_prescription_id,
        platform_type:that.platform_type
      };
      http
        .delete(
          "/drugs/" + that.doctor_id + "/self_prescriptions",
          { params: params },
          {
            headers: { Authorization: that.token }
          }
        )
        .then(function(res) {
          if (res.data.status_code == 200) {
            that.getDate(true);
            that.delete_popup_show = false;
          }
        });
    },
    toEdit(item) {
      if (item) {
        item["content"] = JSON.parse(item["content"]);
        localStorage.setItem("local_prescription", JSON.stringify(item));
        this.$router.push({
          path: "/editPrescription",
          query: { prescription_id: item["prescription_id"] }
        });
      } else {
        localStorage.removeItem("local_prescription");
        this.$router.push({ path: "/editPrescription" });
      }
    },
    pageback() {
      if (this.$route.query.t) {
        window.history.back();
        return true;
      } else {
        return null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.common-home-content {
  height: 100%;
  padding-top: 46px;
  box-sizing: border-box;
  overflow: hidden;
}

.common-scroll {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding-bottom: 10px;
}

.header-right-btn {
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(172, 76, 56, 1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
}

.search-input {
  width: 100%;
  height: 36px;
  padding: 0 15px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333333;
  position: fixed;
  top: 0;
  left: 0;

  .van-search__content {
    padding-left: 0;
    background: #f4f4f4;
    border-radius: 17px;

    .van-field {
      border: 0;
      box-shadow: none;
    }
  }
}

.prescriptions-ul {
  margin-top: 5px;
  width: 100%;
  box-sizing: border-box;

  & > li {
    margin-bottom: 10px;
    width: 100%;
    padding: 20px 10px 17px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 10px;

    .name {
      line-height: 24px;
      font-size: 16px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #ac4b38;
      padding-right: 50px;
      position: relative;

      .delete {
        display: block;
        width: 13px;
        height: 16px;
        background: url("../../assets/images/prescription/delete2.png")
          no-repeat;
        background: none \9;
        filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/prescription/delete2.png', sizingMethod='scale');
        -webkit-background-size: 13px 16px;
        -moz-background-size: 13px 16px;
        background-size: 13px 16px;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
      }
    }

    .content {
      margin-top: 10px;
      line-height: 20px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #666666;
    }
  }
}

.no-more {
  color: #969799;
  font-size: 14px;
  line-height: 50px;
  text-align: center;
}

.delete-popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 25px 24px;

  .title {
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }

  .prompt {
    margin-top: 34px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }

  .btns {
    margin-top: 42px;
    width: 100%;
    box-sizing: border-box;

    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }

    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}

.not-prescriptions {
  margin-top: 182px;
  width: 100%;
  display: inline-block;
  text-align: center;

  img {
    width: 118px;
  }

  .title {
    margin-top: 17px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(154, 154, 154, 1);
  }
}

.van-popup {
  border-radius: 10px;
}
</style>
<style>
.search-input .van-field__left-icon {
  margin-left: 13px;
  margin-right: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/prescription/mangeprescriptions.vue